<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M2681.06 3563.05l881.99 0 0 -881.99 -881.99 0 0 881.99zm0 -1322.9l881.99 0 0 -881.98 -881.99 0 0 881.98zm-1322.89 -1322.89l881.98 0 0 -881.99 -881.98 0 0 881.99zm1322.89 0l881.99 0 0 -881.99 -881.99 0 0 881.99zm-1322.89 1322.89l881.98 0 0 -881.98 -881.98 0 0 881.98zm-1322.9 0l881.99 0 0 -881.98 -881.99 0 0 881.98zm0 1322.9l881.99 0 0 -881.99 -881.99 0 0 881.99zm1322.9 0l881.98 0 0 -881.99 -881.98 0 0 881.99zm-1322.9 -2645.79l881.99 0 0 -881.99 -881.99 0 0 881.99z"/>
  </g>
 </g>
</svg>
